// src/commands/commands.ts
Office.onReady(() => {
  // 功能区按钮命令处理（如有需要可在此扩展）
});
